module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySets@2x.a8840a4.webp";